import { render, staticRenderFns } from "./Carport.vue?vue&type=template&id=06875605&"
import script from "./Carport.vue?vue&type=script&lang=js&"
export * from "./Carport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports